import { createContext } from 'react'

const auctionContext = createContext()

export default auctionContext
